module.exports = __webpack_public_path__ + "cd607c84ad2ac726b2757e356aa8f4fd.png";